'use es6';

import { FILTER_LINK_CLICKED } from 'customer-data-filters/filterQueryFormat/UsageSubActionTypes';
import FilterOperatorType from '../propTypes/FilterOperatorType';
import FilterUserAction from 'customer-data-filters/filterQueryFormat/FilterUserAction';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import UILink from 'UIComponents/link/UILink';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
import { getDynamicFilterFamilyBasis } from '../../filterQueryFormat/DynamicFilterFamilies';
import { CONTACT_LIST, IN_LIST } from '../../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { jsx as _jsx } from "react/jsx-runtime";
const _getLinkMessage = filterFamily => {
  const filterFamilyBasis = getDynamicFilterFamilyBasis(filterFamily) || filterFamily;
  return filterFamilyBasis === IN_LIST || filterFamilyBasis === CONTACT_LIST ? 'customerDataFilters.FilterEditorPanel.seeList' : 'customerDataFilters.FilterEditorPanel.seeDetails';
};
const FieldLink = props => {
  const {
    filterFamily,
    onUserAction,
    panelKey,
    url,
    value
  } = props;
  const onClick = typeof onUserAction === 'function' ? () => onUserAction(FilterUserAction({
    condition: get('name', value),
    filterFamily,
    panelKey,
    refinement: getIn(['refinement', 'name'], value),
    subAction: FILTER_LINK_CLICKED
  })) : undefined;
  return /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: url,
    onClick: onClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: _getLinkMessage(filterFamily)
    })
  });
};
FieldLink.displayName = 'FieldLink';
FieldLink.propTypes = {
  filterFamily: PropTypes.string.isRequired,
  onUserAction: PropTypes.func,
  panelKey: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  value: FilterOperatorType
};
export default FieldLink;